<template>
    <th :class="{right: alignedRight}" :style="extraStyle">
        <span v-if="this.sort === 'asc' || this.sort === 'desc'" class="name">
            <strong><slot></slot></strong>
        </span>
        <span v-else class="name">
            <slot></slot>
        </span>
        <span class="sorting" v-if="isSortable">
            <a :class="['asc', { active: (sort === 'asc') }]" title="Vzestupně" @click.prevent="changeSort('asc')" v-translate>Vzestupně</a>
            <a :class="['desc', { active: (sort === 'desc') }]" title="Sestupně" @click.prevent="changeSort('desc')" v-translate>Sestupně</a>
        </span>
    </th>
</template>

<script>
export default {
  name: 'sorting-table-title',
  props: {
    column: {
      type: String,
      default: ''
    },
    extraStyle: {
      type: Object,
    },
    sortable: {
      type: Boolean,
      default: true
    },
    sort: [String, Boolean],
    alignedRight: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    isSortable() {
      return this.column !== '' && this.sortable
    }
  },
  methods: {
    changeSort(direction) {
      if (this.sort === false || direction !== this.sort) {
        this.$emit('changeSorting', { column: this.column, direction: direction })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SortingTableTitle.vue